import FormattedMessage from 'I18n/components/FormattedMessage';
import { NavMarker } from 'react-rhumb';
import { useSelector } from 'react-redux';
import emptyFunction from 'react-utils/emptyFunction';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module
import { getIsJitaUser } from '../selectors/AccessSelector';
import { Button } from 'foundations-components/transitional/components/Button';
import { Header } from 'foundations-components/transitional/components/Header';
import { jsx as _jsx } from "react/jsx-runtime";
const MeetingsAdminHeader = ({
  routeToCreateMeetingLink = emptyFunction
}) => {
  const isJitaUser = useSelector(state => getIsJitaUser(state));
  return /*#__PURE__*/_jsx(Header, {
    use: "condensed",
    flush: true,
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "calendarView.header"
    }),
    children: /*#__PURE__*/_jsx(NavMarker, {
      name: "CREATE_BUTTON_LOAD",
      children: /*#__PURE__*/_jsx(Button, {
        disabled: isJitaUser,
        use: "primary",
        "data-selenium-test": "create-meeting-button",
        onClick: routeToCreateMeetingLink,
        size: "small",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "editLink.createNew"
        })
      })
    })
  });
};
export default MeetingsAdminHeader;